import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-13 «Кредити» (F-020). Тека с этим файлом — и есть регистрация
// (`../registry.ts`): пункт «Кредити» раздела «ГРОШІ» оживает вместе с ней (решение 028).
// Вход — пункт меню, часть «Платежі за кредитами» на `S-01`, дело «кредити без умов» и
// прямой адрес.
export const meta: SurfaceMeta = {
  code: "S-13",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s13_title");
  },
  path: "/s-13",
};
